// Set on the first real shopper interaction; used to tell user-driven variant changes from
// the programmatic ones fired while the page initialises (see stupdateURL).
if (!window.__mjInteractionListener) {
  window.__mjInteractionListener = true;
  ["pointerdown", "keydown", "touchstart"].forEach((type) => {
    window.addEventListener(type, () => { window.__mjUserInteracted = true; }, { capture: true, passive: true, once: true });
  });
}

const RELOAD_TIMER = 300;
const SP_OBJECT = {
  ajxcartRefresh: "cart-update",
  qtyRefresh: "quantity-update",
  swatchUpdate: "variant-change",
};
let users = {};
function user(eventName, callback) {
  if (users[eventName] === undefined) {
    users[eventName] = [];
  }
  users[eventName] = [...users[eventName], callback];
  return function unuser() {
    users[eventName] = users[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}
function live(eventName, data) {
  if (users[eventName]) {
    users[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
function animate() {
  document.documentElement.style.setProperty(
    "--viewport-height",
    `${window.innerHeight}px`,
  );
}
["load", "scroll", "resize"].forEach((eventName) =>
  window.addEventListener(eventName, animate),
);
function getClickable(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
const getScrollTop = (element) => {
  let offsetTop = 0;
  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop;
    }
  } while ((element = element.offsetParent));
  return offsetTop;
};
const portView = (element) => {
  const windowBottom = window.pageYOffset + window.innerHeight;
  return windowBottom >= getScrollTop(element);
};
if (!window.Shopify.designMode) {
  document.querySelectorAll("[data-fade-in]").forEach((element) => {
    ["load", "scroll", "shopify:section:load"].forEach((eventName) => {
      window.addEventListener(eventName, () => {
        if (!portView(element)) {
          return;
        }
        element.classList.add("fade-in");
      });
    });
  });
}
const triggerClickFocus = {};
function triggerClick(container, tagClicked = container) {
  var elements = getClickable(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  triggerClickClose();
  triggerClickFocus.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;
    document.addEventListener("keydown", triggerClickFocus.keydown);
  };
  triggerClickFocus.focusout = function () {
    document.removeEventListener("keydown", triggerClickFocus.keydown);
  };
  triggerClickFocus.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener("focusout", triggerClickFocus.focusout);
  document.addEventListener("focusin", triggerClickFocus.focusin);
  tagClicked.focus();
  if (
    tagClicked.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(tagClicked.type) &&
    tagClicked.value
  ) {
    tagClicked.setSelectionRange(0, tagClicked.value.length);
  }
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  triggerShow();
}
function triggerShow() {
  const keyCont = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let nowClickedTag = null;
  let clickCont = null;
  window.addEventListener("keydown", (event) => {
    if (keyCont.includes(event.code.toUpperCase())) {
      clickCont = false;
    }
  });
  window.addEventListener("mousedown", (event) => {
    clickCont = true;
  });
  window.addEventListener(
    "focus",
    () => {
      if (nowClickedTag) nowClickedTag.classList.remove("focused");
      if (clickCont) return;
      nowClickedTag = document.activeElement;
      nowClickedTag.classList.add("focused");
    },
    true,
  );
}
function triggerClickClose(tagClicked = null) {
  document.removeEventListener("focusin", triggerClickFocus.focusin);
  document.removeEventListener("focusout", triggerClickFocus.focusout);
  document.removeEventListener("keydown", triggerClickFocus.keydown);
  if (tagClicked) tagClicked.focus();
}
function escClick(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

// Helper function to add a new cart line item with unique group ID
async function addNewCartLine(variantId, qtyBoxElement) {
  const groupId =
    Date.now().toString(36) + Math.random().toString(36).substr(2);

  // Create and show loading overlay
  const loadingOverlay = document.createElement("div");
  loadingOverlay.className = "delpro-loading-overlay";
  loadingOverlay.innerHTML = `
    <div class="delpro-loading-content">
      <div class="delpro-spinner"></div>
      <p class="delpro-loading-text">Adding item...</p>
    </div>
  `;
  document.body.appendChild(loadingOverlay);

  // Trigger reflow and add active class
  loadingOverlay.offsetHeight;
  loadingOverlay.classList.add("active");

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId),
            quantity: 1,
            properties: {
              _product_group_id: groupId,
              _is_upsell: "false",
            },
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add item to cart");
    }

    // Update cart count in header
    const cartData = await fetch("/cart.json").then((res) => res.json());
    const cartCountElement = document.querySelector(
      '.ajax-cart-count span[aria-hidden="true"]',
    );
    const cartCountVisuallyHidden = document.querySelector(
      ".ajax-cart-count .visually-hidden",
    );

    if (cartCountElement && cartData.item_count < 100) {
      cartCountElement.textContent = cartData.item_count;
    }
    if (cartCountVisuallyHidden) {
      cartCountVisuallyHidden.textContent = `Basket ${cartData.item_count}`;
    }

    // Refresh cart UI
    const ajaxItems = document.querySelector("ajax-items");
    if (ajaxItems && typeof ajaxItems.onCartUpdate === "function") {
      ajaxItems.onCartUpdate();
    } else {
      // Fallback: reload page
      window.location.reload();
    }

    // Remove loading overlay after cart updates
    setTimeout(() => {
      loadingOverlay.classList.remove("active");
      setTimeout(() => loadingOverlay.remove(), 300);
    }, 500);
  } catch (error) {
    console.error("Error adding new line item:", error);
    loadingOverlay.classList.remove("active");
    setTimeout(() => loadingOverlay.remove(), 300);
  }
}

class qtyBox extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.qtyInputupdate.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.BtTrigger.bind(this)),
    );
  }
  qtyInputupdateBlank = undefined;
  connectedCallback() {
    this.requreQtyterm();
    this.qtyInputupdateBlank = user(
      SP_OBJECT.qtyRefresh,
      this.requreQtyterm.bind(this),
    );
  }
  disconnectedCallback() {
    if (this.qtyInputupdateBlank) {
      this.qtyInputupdateBlank();
    }
  }
  qtyInputupdate(event) {
    this.requreQtyterm();
  }
  BtTrigger(event) {
    event.preventDefault();

    // Get the button element (event.target could be the icon inside)
    const button = event.target.closest("button");
    const buttonName = button ? button.name : event.target.name;

    // Check if this is a cart page qty-box (add new line instead of increment)
    if (this.dataset.cartQty === "true" && buttonName === "plus") {
      const variantId = this.dataset.variantId;
      if (variantId) {
        addNewCartLine(variantId, this);
        return;
      }
    }

    // Default behavior for minus button and non-cart contexts
    const pastValue = this.input.value;
    buttonName === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (pastValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
  requreQtyterm() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const qtyDecrease = this.querySelector(".qty-bt[name='minus']");
      qtyDecrease.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const qtyIncrease = this.querySelector(".qty-bt[name='plus']");
      qtyIncrease.classList.toggle("disabled", value >= max);
    }
  }
}
customElements.define("qty-box", qtyBox);
function stdebounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function stFetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );
  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
class stModalcontent extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="stclose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");

    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    triggerClick(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    triggerClickClose(this.openedBy);
  }
}
customElements.define("modal-dialog", stModalcontent);
class stModalshower extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("a");
    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("qv-modal", stModalshower);
class Swatchoption extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.swatchUpdate);
  }

  connectedCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");

    if (variantId) {
      window.addEventListener("load", () => {
        setTimeout(() => {
          // When variant ID is in URL, explicitly select the correct dropdown values
          const variants = this.stSwatchDate();
          const targetVariant = variants.find(
            (v) => v.id.toString() === variantId,
          );

          if (targetVariant) {
            const selects = this.querySelectorAll("select");
            targetVariant.options.forEach((optionValue, index) => {
              if (selects[index] && selects[index].value !== optionValue) {
                selects[index].value = optionValue;
              }
            });
          }

          this.itemsUpdate();
          this.stupdateMasterId();
          this.updateSwatchStatuses();

          if (
            typeof jQuery !== "undefined" &&
            jQuery(".pro_details_pos .swiper-slide").length >= 1
          ) {
            if (this.swatch && this.swatch.featured_image) {
              this.updateImage();
            }
          }
        }, 200);
      });
    } else {
      // No variant in URL - handle initial load
      window.addEventListener("load", () => {
        setTimeout(() => {
          this.itemsUpdate();
          this.stupdateMasterId();
          this.updateSwatchStatuses();
        }, 200);
      });
    }
  }

  findFirstAvailableVariant(selectedOptions) {
    const variants = this.stSwatchDate();

    for (let variant of variants) {
      if (!variant.available) continue;

      let matches = true;
      for (let i = 0; i < selectedOptions.length; i++) {
        if (selectedOptions[i] && variant.options[i] !== selectedOptions[i]) {
          matches = false;
          break;
        }
      }

      if (matches) {
        return variant;
      }
    }

    return null;
  }

  swatchUpdate() {
    this.itemsUpdate();
    this.stupdateMasterId();

    if (!this.swatch) {
      const variants = this.stSwatchDate();

      const variantExists = variants.some((variant) =>
        variant.options.every((opt, idx) => opt === this.options[idx]),
      );

      if (variantExists) {
        this.btAddButton(true, "Out of Stock", true);
      }

      const selectedOptions = [...this.options];

      const availableVariant = this.findFirstAvailableVariant([
        selectedOptions[0],
        null,
        null,
      ]);

      if (availableVariant) {
        const selects = this.querySelectorAll("select");
        availableVariant.options.forEach((optionValue, index) => {
          if (selects[index] && selects[index].value !== optionValue) {
            selects[index].value = optionValue;

            const event = new Event("change", { bubbles: true });
            selects[index].dispatchEvent(event);
          }
        });

        this.itemsUpdate();
        this.stupdateMasterId();
      }
    }

    this.btAddButton(true, "", false);
    this.stErrortxtRemove();
    this.updateSwatchStatuses();

    if (!this.swatch) {
      this.btAddButton(true, "", true);
      this.stInaccessible();
    } else {
      this.stupdateURL();
      this.changeSwatchInput();
      this.includeProInf();
      this.updateDiscount();
      this.updateImage();
    }
  }

  updateImage() {
    var product_id = this.swatch.featured_image.product_id;
    var section_id = this.getAttribute("data-section");

    if (this.swatch && this.swatch.featured_image) {
      if (jQuery(".pro_details_pos .swiper-slide").length >= 1) {
        var layout = jQuery(
          "#slider-small-" +
            section_id +
            "-" +
            product_id +
            ' .swiper-slide[data-image-id="' +
            this.swatch.featured_media.id +
            '"]',
        ).attr("data-layout");
        var swiperContainer = document.querySelector(
          ".slider-small-" + section_id + "-" + product_id,
        );

        // Check if swiper is already initialized
        if (swiperContainer && swiperContainer.swiper) {
          // Swiper exists, just navigate to the correct slide
          const unGroupMedia = document.querySelector(
            `#slider-small-` +
              section_id +
              `-` +
              product_id +
              ` .swiper-slide[data-image-id="` +
              this.swatch.featured_media.id +
              `"]`,
          );
          const mediaIndex = unGroupMedia.getAttribute("data-index");
          var new_index = parseInt(mediaIndex) - 1;

          // Skip navigation if already at the correct slide (prevents flicker on initial load with variant URL)
          if (swiperContainer.swiper.realIndex === new_index) {
            return;
          }

          // Use slideToLoop for loop-enabled swipers to handle real index correctly
          // Speed set to 0 for instant slide change when clicking color variants (no scroll animation)
          if (swiperContainer.swiper.params.loop) {
            swiperContainer.swiper.slideToLoop(new_index, 0, false);
          } else {
            swiperContainer.swiper.slideTo(new_index, 0, false);
          }

          // Also update big slider if it exists
          var bigSwiperContainer = document.querySelector(
            ".slider-big-" + section_id + "-" + product_id,
          );
          if (bigSwiperContainer && bigSwiperContainer.swiper) {
            // Speed set to 0 for instant slide change when clicking color variants
            if (bigSwiperContainer.swiper.params.loop) {
              bigSwiperContainer.swiper.slideToLoop(new_index, 0, false);
            } else {
              bigSwiperContainer.swiper.slideTo(new_index, 0, false);
            }
          }
          return;
        }

        if (layout == "full-slider") {
          // Get total slide count for loopedSlides
          var totalSlides = jQuery(
            "#slider-small-" + section_id + "-" + product_id + " .swiper-slide",
          ).length;

          var swiper = new Swiper(
            ".slider-small-" + section_id + "-" + product_id,
            {
              spaceBetween: 15,
              speed: 300,
              slidesPerView: 5,
              loop: true,
              loopedSlides: totalSlides,
              navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
              },
              breakpoints: {
                0: {
                  slidesPerView: 5,
                },
                320: {
                  slidesPerView: 5,
                },
                480: {
                  slidesPerView: 5,
                },
              },
            },
          );

          const unGroupMedia = document.querySelector(
            `#slider-small-` +
              section_id +
              `-` +
              product_id +
              ` .swiper-slide[data-image-id="` +
              this.swatch.featured_media.id +
              `"]`,
          );
          const mediaIndex = unGroupMedia.getAttribute("data-index");
          var new_index = parseInt(mediaIndex) - 1;

          if (mediaIndex == 1) {
            swiper.destroy();
            var swiper = new Swiper(
              ".slider-small-" + section_id + "-" + product_id,
              {
                autoHeight: true,
                spaceBetween: 15,
                speed: 300,
                slidesPerView: 5,
                loop: true,
                loopedSlides: totalSlides,
                navigation: {
                  nextEl: ".button-next",
                  prevEl: ".button-prev",
                },
                breakpoints: {
                  0: {
                    slidesPerView: 5,
                  },
                  320: {
                    slidesPerView: 5,
                  },
                  480: {
                    slidesPerView: 5,
                  },
                },
              },
            );
          } else {
            swiper.slideToLoop(new_index, 0, false); // Instant slide change for variant clicks
          }
        } else {
          // Thumb-slider layout
          var totalSlides = jQuery(
            "#slider-small-" + section_id + "-" + product_id + " .swiper-slide",
          ).length;
          var slider_pos = jQuery(
            "#slider-small-" +
              section_id +
              "-" +
              product_id +
              ' .swiper-slide[data-image-id="' +
              this.swatch.featured_media.id +
              '"]',
          ).attr("data-slide");

          if (slider_pos == "vertical") {
            var dr = "vertical";
            var sv = "auto";
          } else {
            var dr = "horizontal";
            var sv = 5;
          }

          var swiper = new Swiper(
            ".slider-small-" + section_id + "-" + product_id,
            {
              autoHeight: true,
              spaceBetween: 15,
              speed: 300,
              slidesPerView: 5,
              direction: dr,
              mousewheel: true,
              slideToClickedSlide: true,
              loop: true,
              loopedSlides: totalSlides,
              breakpoints: {
                0: {
                  slidesPerView: 5,
                  direction: "horizontal",
                },
                320: {
                  slidesPerView: 5,
                  direction: "horizontal",
                },
                480: {
                  slidesPerView: 5,
                  direction: "horizontal",
                },
              },
            },
          );

          var swiper2 = new Swiper(
            ".slider-big-" + section_id + "-" + product_id,
            {
              spaceBetween: 0,
              slidesPerView: 1,
              speed: 300,
              autoHeight: true,
              slideToClickedSlide: true,
              loop: true,
              loopedSlides: totalSlides,
              navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
              },
              thumbs: {
                swiper: swiper,
              },
            },
          );

          const unGroupMedia = document.querySelector(
            `#slider-small-` +
              section_id +
              `-` +
              product_id +
              ` .swiper-slide[data-image-id="` +
              this.swatch.featured_media.id +
              `"]`,
          );
          const mediaIndex = unGroupMedia.getAttribute("data-index");
          var new_index = parseInt(mediaIndex) - 1;

          if (mediaIndex == 1) {
            swiper2.destroy();
            var swiper2 = new Swiper(
              ".slider-big-" + section_id + "-" + product_id,
              {
                spaceBetween: 0,
                slidesPerView: 1,
                speed: 300,
                autoHeight: true,
                slideToClickedSlide: true,
                loop: true,
                loopedSlides: totalSlides,
                navigation: {
                  nextEl: ".button-next",
                  prevEl: ".button-prev",
                },
                thumbs: {
                  swiper: swiper,
                },
              },
            );
          } else {
            swiper2.slideToLoop(new_index, 0, false); // Instant slide change for variant clicks
          }
        }
      }
    }
  }

  updateDiscount() {
    var $ProductDiscount = $("#ProductDiscount"),
      $ProductDiscount2 = $("#ProductDiscount2"),
      $productPrice = $("#ProductPrice"),
      $comparePrice = $("#ComparePrice"),
      $SaveText = $("#SaveText"),
      $Saving = $("#Saving");

    // Format prices using Shopify's money format
    var formattedPrice = Shopify.formatMoney(
      this.swatch.price,
      window.money_format,
    );
    var formattedComparePrice = this.swatch.compare_at_price
      ? Shopify.formatMoney(this.swatch.compare_at_price, window.money_format)
      : null;

    // Update the product price
    $productPrice.html(formattedPrice);

    // Check if there's a compare price and it's greater than the current price
    if (
      this.swatch.compare_at_price &&
      this.swatch.compare_at_price > this.swatch.price
    ) {
      // Calculate discount percentage
      var discountPercent = (
        ((this.swatch.compare_at_price - this.swatch.price) * 100.0) /
        this.swatch.compare_at_price
      ).toFixed();

      // Calculate savings amount
      var savingsAmount = this.swatch.compare_at_price - this.swatch.price;
      var formattedSavings = Shopify.formatMoney(
        savingsAmount,
        window.money_format,
      );

      // Update and show discount percentage
      $ProductDiscount.html(discountPercent);
      $ProductDiscount.show();
      $ProductDiscount2.show();

      // Update and show compare price
      $comparePrice.html(formattedComparePrice);
      $comparePrice.show();

      // Handle SaveText - create it if it doesn't exist
      if ($SaveText.length === 0) {
        // Create the SaveText element if it doesn't exist
        var saveTextHtml =
          '<p class="you-save" id="SaveText" style="display: none;">You save <span id="Saving"></span></p>';

        // Find the best place to insert it (after the price info section)
        var $priceBox = $(".price-box");
        if ($priceBox.length > 0) {
          $(saveTextHtml).insertAfter($priceBox.closest(".pro-prlb"));
          // Re-select the elements after creating them
          $SaveText = $("#SaveText");
          $Saving = $("#Saving");
        }
      }

      // Update and show savings text and amount
      if ($Saving.length > 0) {
        $Saving.html(formattedSavings);
      }
      if ($SaveText.length > 0) {
        $SaveText.show();
      }

      // Add the on-sale class to price box
      $(".price-box").addClass("price--on-sale");
    } else {
      // Hide all discount-related elements when no discount
      $ProductDiscount.hide();
      $ProductDiscount2.hide();
      if ($SaveText.length > 0) {
        $SaveText.hide();
      }
      $comparePrice.hide();

      // Remove the on-sale class
      $(".price-box").removeClass("price--on-sale");
    }
  }

  itemsUpdate() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }
  stupdateMasterId() {
    this.swatch = this.stSwatchDate().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  stupdateURL() {
    if (!this.swatch || this.dataset.updateUrl === "false") return;
    // Only rewrite the address after the shopper has actually interacted. Pickers fire programmatic
    // "change" events while the page loads, and every URL change is counted by GA4 as an extra page
    // view (history-change tracking), so a single product view was being recorded several times.
    if (!window.__mjUserInteracted) return;
    const nextUrl = `${this.dataset.url}?variant=${this.swatch.id}`;
    if (window.location.pathname + window.location.search === nextUrl) return;
    window.history.replaceState({}, "", nextUrl);
  }
  changeSwatchInput() {
    const stproductForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    stproductForms.forEach((stproductForm) => {
      const input = stproductForm.querySelector('input[name="id"]');
      input.value = this.swatch.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  updateSwatchStatuses() {
    const selectedColor = this.options[0]; // First option is color
    const variants = this.stSwatchDate();

    // Get ALL variants with the selected color (including out of stock)
    const colorVariants = variants.filter(
      (variant) => variant.option1 === selectedColor,
    );

    // For each subsequent option (size, headboard, etc.)
    const selectElements = this.querySelectorAll("select");

    selectElements.forEach((select, index) => {
      if (index === 0) return; // Skip color selector

      // Get all possible values that EXIST for this option (regardless of stock)
      const existingValues = new Set();
      const availableValues = new Set();

      colorVariants.forEach((variant) => {
        if (variant.options[index]) {
          existingValues.add(variant.options[index]);
          if (variant.available) {
            availableValues.add(variant.options[index]);
          }
        }
      });

      // Update options: hide non-existent, show but mark out-of-stock
      const options = select.querySelectorAll("option");
      options.forEach((option) => {
        const value = option.value;

        if (!existingValues.has(value)) {
          // This combination doesn't exist at all - hide it
          option.style.display = "none";
          option.disabled = true;
          option.classList.add("hidden");
        } else if (!availableValues.has(value)) {
          // Exists but out of stock - show but mark as out of stock
          option.style.display = "";
          option.disabled = false;
          option.classList.remove("hidden");
          option.innerText = value + " - Out of Stock";
        } else {
          // Available - show normally
          option.style.display = "";
          option.disabled = false;
          option.classList.remove("hidden");
          option.innerText = value;
        }
      });

      // If current selection doesn't exist, select first existing option
      if (!existingValues.has(select.value)) {
        const firstExisting = Array.from(existingValues)[0];
        if (firstExisting) {
          select.value = firstExisting;
        }
      }
    });
  }
  stInAva(stlistOfOptions, stlistOfAvOptions) {
    stlistOfOptions.forEach((input) => {
      if (stlistOfAvOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
        input.style.display = ""; // Make sure it's visible
        input.disabled = false;
      } else {
        input.innerText = window.stThemeString.StrunavailableOp.replace(
          "[value]",
          input.getAttribute("value"),
        );
        input.style.display = "none"; // Hide unavailable options
        input.disabled = true;
      }
    });
  }
  stErrortxtRemove() {
    const section = this.closest("section");
    if (!section) return;
    const stproductForm = section.querySelector("cart-action");
    if (stproductForm) stproductForm.stHandErrorTxt();
  }
  includeProInf() {
    const reqSwatchId = this.swatch.id;
    const stScId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${reqSwatchId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.swatch.id !== reqSwatchId) return;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const goal = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuGoal = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const invGoal = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        if (source && goal) goal.innerHTML = source.innerHTML;
        if (inventorySource && invGoal)
          invGoal.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuGoal) {
          skuGoal.innerHTML = skuSource.innerHTML;
          skuGoal.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden"),
          );
        }
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("visibility-hidden");
        if (invGoal)
          invGoal.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === "",
          );
        const cartBtUpdated = html.getElementById(
          `ProductSubmitButton-${stScId}`,
        );
        this.btAddButton(
          cartBtUpdated ? cartBtUpdated.hasAttribute("disabled") : true,
          window.stThemeString.Strsoldout,
        );
        live(SP_OBJECT.swatchUpdate, {
          data: {
            stScId,
            html,
            variant: this.swatch,
          },
        });
      });
  }
  btAddButton(disable = true, text, modifyClass = true) {
    const stproductForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!stproductForm) return;
    const cartBt = stproductForm.querySelector('[name="add"]');
    const cartBtText = stproductForm.querySelector('[name="add"] > span');

    if (!cartBt) return;
    if (disable) {
      cartBt.setAttribute("disabled", "disabled");
      if (text) cartBtText.textContent = text;
    } else {
      cartBt.removeAttribute("disabled");
      cartBtText.textContent = window.stThemeString.Straddcart;
    }
    if (!modifyClass) return;

    const stickyproductForm = document.querySelector(".sticky-btn-atc");
    if (!stickyproductForm) return;
    const stickyBt = stickyproductForm.querySelector('[name="add"]');
    const stickyBtText = stickyproductForm.querySelector('[name="add"] > span');

    if (!stickyBt) return;
    if (disable) {
      stickyBt.setAttribute("disabled", "disabled");
      if (text) stickyBtText.textContent = window.stThemeString.Strsoldout;
    } else {
      stickyBt.removeAttribute("disabled");
      stickyBtText.textContent = window.stThemeString.Straddcart;
    }
  }
  stInaccessible() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const cartBt = button.querySelector('[name="add"]');
    const cartBtText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    if (!cartBt) return;
    cartBtText.textContent = window.stThemeString.Strunavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }
  stSwatchDate() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("selects-box", Swatchoption);

class SwatchCheck extends Swatchoption {
  constructor() {
    super();
  }

  connectedCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");

    if (variantId) {
      window.addEventListener("load", () => {
        setTimeout(() => {
          // When variant ID is in URL, explicitly select the correct radio buttons
          // This is needed because Shopify's server-side rendering doesn't always respect the URL variant
          const variants = this.stSwatchDate();
          const targetVariant = variants.find(
            (v) => v.id.toString() === variantId,
          );

          if (targetVariant) {
            const varItems = this.querySelectorAll("varitem");

            targetVariant.options.forEach((optionValue, index) => {
              if (varItems[index]) {
                const radios = varItems[index].querySelectorAll(
                  'input[type="radio"]',
                );
                const targetRadio = Array.from(radios).find(
                  (r) => r.value === optionValue,
                );

                if (targetRadio && !targetRadio.checked) {
                  targetRadio.checked = true;
                }
              }
            });
          }

          // Always update after setting radio buttons
          this.itemsUpdate();
          this.stupdateMasterId();
          this.updateSwatchStatuses();

          if (
            typeof jQuery !== "undefined" &&
            jQuery(".pro_details_pos .swiper-slide").length >= 1
          ) {
            if (this.swatch && this.swatch.featured_image) {
              this.updateImage();
            }
          }
        }, 200);
      });
    } else {
      // No variant ID in URL - handle initial load with auto-selection
      window.addEventListener("load", () => {
        setTimeout(() => {
          this.itemsUpdate();
          this.stupdateMasterId();

          // Check if the initially selected variant is unavailable
          if (!this.swatch || !this.swatch.available) {
            // Find first available variant
            const variants = this.stSwatchDate();
            const availableVariant = variants.find(
              (variant) => variant.available,
            );

            if (availableVariant) {
              // Update radio buttons to match available variant
              const varItems = this.querySelectorAll("varitem");

              availableVariant.options.forEach((optionValue, index) => {
                if (varItems[index]) {
                  const radios = varItems[index].querySelectorAll(
                    'input[type="radio"]',
                  );
                  const targetRadio = Array.from(radios).find(
                    (r) => r.value === optionValue,
                  );

                  if (targetRadio) {
                    targetRadio.checked = true;
                  }
                }
              });

              // Re-run update with new selection
              this.itemsUpdate();
              this.stupdateMasterId();
            }
          }

          this.updateSwatchStatuses();

          // NOW update the image based on the selected (possibly auto-selected) variant
          if (
            typeof jQuery !== "undefined" &&
            jQuery(".pro_details_pos .swiper-slide").length >= 1
          ) {
            if (this.swatch && this.swatch.featured_image) {
              setTimeout(() => {
                this.updateImage();
              }, 300);
            }
          }
        }, 200);
      });
    }
  }

  stInAva(stlistOfOptions, stlistOfAvOptions) {
    stlistOfOptions.forEach((input) => {
      if (stlistOfAvOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
        input.disabled = false;
        const label = input.nextElementSibling;
        if (label) {
          label.style.display = "";
          label.style.opacity = "1";
        }
        input.style.display = "";
      } else {
        input.classList.add("disabled");
        input.disabled = true;
        const label = input.nextElementSibling;
        if (label) {
          label.style.display = "none";
        }
        input.style.display = "none";
      }
    });
  }

  itemsUpdate() {
    const varitems = Array.from(this.querySelectorAll("varitem"));
    this.options = varitems.map((varitem) => {
      return Array.from(varitem.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }

  updateSwatchStatuses() {
    const selectedColor = this.options[0];
    const variants = this.stSwatchDate();

    const colorVariants = variants.filter(
      (variant) => variant.option1 === selectedColor,
    );

    const varItems = this.querySelectorAll("varitem");

    varItems.forEach((varItem, index) => {
      if (index === 0) return;

      const existingValues = new Set();
      const availableValues = new Set();

      colorVariants.forEach((variant) => {
        if (variant.options[index]) {
          existingValues.add(variant.options[index]);
          if (variant.available) {
            availableValues.add(variant.options[index]);
          }
        }
      });

      const radioInputs = varItem.querySelectorAll('input[type="radio"]');
      radioInputs.forEach((radio) => {
        const value = radio.value;
        const label = radio.nextElementSibling;

        if (!existingValues.has(value)) {
          radio.style.display = "none";
          radio.disabled = true;
          radio.classList.add("disabled", "hidden");
          if (label) {
            label.style.display = "none";
            label.classList.add("hidden");
          }
        } else if (!availableValues.has(value)) {
          radio.style.display = "";
          radio.disabled = false;
          radio.classList.add("out-of-stock");
          radio.classList.remove("disabled", "hidden");
          if (label) {
            label.style.display = "";
            label.style.opacity = "0.6";
            label.classList.add("out-of-stock-label");
            label.classList.remove("hidden");
            if (!label.querySelector(".stock-indicator")) {
              const stockIndicator = document.createElement("span");
              stockIndicator.className = "stock-indicator";
              stockIndicator.textContent = " (Out of Stock)";
              stockIndicator.style.fontSize = "0.9em";
              stockIndicator.style.color = "#999";
              label.appendChild(stockIndicator);
            }
          }
        } else {
          radio.style.display = "";
          radio.disabled = false;
          radio.classList.remove("disabled", "out-of-stock", "hidden");
          if (label) {
            label.style.display = "";
            label.style.opacity = "1";
            label.classList.remove("hidden");
            const stockIndicator = label.querySelector(".stock-indicator");
            if (stockIndicator) {
              stockIndicator.remove();
            }
          }
        }
      });

      const checkedRadio = varItem.querySelector('input[type="radio"]:checked');
      if (checkedRadio && !existingValues.has(checkedRadio.value)) {
        const firstExisting = Array.from(existingValues)[0];
        if (firstExisting) {
          const targetRadio = Array.from(radioInputs).find(
            (r) => r.value === firstExisting,
          );
          if (targetRadio) {
            targetRadio.checked = true;
          }
        }
      }
    });
  }

  swatchUpdate() {
    this.itemsUpdate();
    this.stupdateMasterId();

    const originalColor = this.options[0];
    let variantWasChanged = false;

    if (!this.swatch) {
      const variants = this.stSwatchDate();
      const selectedColor = this.options[0];

      let availableVariant = variants.find(
        (variant) => variant.available && variant.option1 === selectedColor,
      );

      if (!availableVariant) {
        availableVariant = variants.find((variant) => variant.available);
        variantWasChanged = true;
      }

      if (availableVariant) {
        const varItems = this.querySelectorAll("varitem");

        availableVariant.options.forEach((optionValue, index) => {
          if (varItems[index]) {
            const radios = varItems[index].querySelectorAll(
              'input[type="radio"]',
            );
            const targetRadio = Array.from(radios).find(
              (r) => r.value === optionValue,
            );

            if (targetRadio && !targetRadio.checked) {
              targetRadio.checked = true;
              variantWasChanged = true;
            }
          }
        });

        this.itemsUpdate();
        this.stupdateMasterId();
      }
    }

    this.btAddButton(true, "", false);
    this.stErrortxtRemove();
    this.updateSwatchStatuses();

    if (!this.swatch) {
      this.btAddButton(true, "", true);
      this.stInaccessible();
    } else {
      this.stupdateURL();
      this.changeSwatchInput();
      this.includeProInf();
      this.updateDiscount();

      if (this.swatch && this.swatch.featured_image) {
        if (variantWasChanged || originalColor !== this.options[0]) {
          const section_id = this.getAttribute("data-section");
          const product_id = this.swatch.featured_image.product_id;
          const swiperContainer = document.querySelector(
            ".slider-small-" + section_id + "-" + product_id,
          );
          const bigSwiperContainer = document.querySelector(
            ".slider-big-" + section_id + "-" + product_id,
          );

          if (swiperContainer && swiperContainer.swiper) {
            swiperContainer.swiper.slideToLoop(0, 0, false);
          }
          if (bigSwiperContainer && bigSwiperContainer.swiper) {
            bigSwiperContainer.swiper.slideToLoop(0, 0, false);
          }

          setTimeout(() => {
            this.updateImage();
          }, 100);
        } else {
          this.updateImage();
        }
      }
    }
  }
}
customElements.define("pr-option", SwatchCheck);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" },
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`,
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          if ($(".item-data").length >= 1) {
            $(".item-data").on("click", function () {
              $(this)
                .parents(".option-block")
                .find(".variant-option")
                .removeClass("active-variant");
              $(this).closest("form-wrap").addClass("active-variant");
              var it_img = $(this).attr("dataimg");
              $(this)
                .parents(".single-product-wrap")
                .find(".product-image .img1 img")
                .attr("src", it_img);
              $(this)
                .parents(".single-product-wrap")
                .find(".product-image .img1 img")
                .attr("srcset", it_img);
              var price = $(this).attr("dataprice");
              var compareprice = $(this).attr("datacompare");
              var stocks = $(this).attr("dataavailable");
              $(this)
                .parents(".single-product-wrap")
                .find(".price-box .new-price")
                .text(Shopify.formatMoney(price, window.money_format));
              if (compareprice > price) {
                $(this)
                  .parents(".single-product-wrap")
                  .find(".price-box .old-price")
                  .show();
                $(this)
                  .parents(".single-product-wrap")
                  .find(".price-box .old-price")
                  .html(Shopify.formatMoney(compareprice, window.money_format));
              } else {
                $(this)
                  .parents(".single-product-wrap")
                  .find(".price-box .old-price")
                  .hide();
              }
            });
          }
          setTimeout(function () {
            $(".wishlist-custom-action").each(function () {
              var attr = $(this).attr("data-handle");
              if (localStorage.getItem("user_wishlist_cnt") !== null) {
                var existing_wishlist = JSON.parse(
                  localStorage.getItem("wishlist"),
                );
                if ($.inArray(attr, existing_wishlist) >= 0) {
                  $(this).addClass("active-wishlist");
                  $(this).removeClass("wishlist-custom-action");
                }
                $(".wishlist-counter").text(
                  localStorage.getItem("user_wishlist_cnt"),
                );
              } else {
                $(".wishlist-counter").text("0");
              }
            });
          });
          setTimeout(function () {
            const productImagesWithDataPro = document.querySelectorAll(
              ".product-image[data-pro]",
            );
            // Loop through each selected element
            productImagesWithDataPro.forEach((element) => {
              // Do something with each element
              const pro_ID = element.getAttribute("data-pro");
              document.getElementById("Quantity-" + pro_ID).onchange =
                function () {
                  var qty_val = $(this).val();
                  $("#quantity-" + pro_ID).val(qty_val);
                };
              document
                .getElementById("pro-add-" + pro_ID)
                .addEventListener("click", function () {
                  var productId = $("#var-" + pro_ID).val();
                  var quantity = $("#quantity-" + pro_ID).val();
                  var url = window.Shopify.routes.root + "cart/add.js";
                  let sectionsToUpdate = "ajax-cart";
                  let sectionsToCount = "ajax-cart-icon";
                  $(this).addClass("loading");
                  $(this).find(".ajax-loader").removeClass("hidden");
                  let requestBody = {
                    items: [
                      {
                        id: productId,
                        quantity: quantity,
                      },
                    ],
                    sections: sectionsToUpdate,
                  };
                  let requestBodyCount = {
                    items: [
                      {
                        id: productId,
                        quantity: quantity,
                      },
                    ],
                    sections: sectionsToCount,
                  };
                  fetch(url, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                  })
                    .then((response) => {
                      return response.json();
                    })
                    .then((data) => {
                      var parsed = $.parseHTML(data.sections["ajax-cart"]);
                      var result = $(parsed).find("#ajaxcart").html();
                      $("#ajaxcart").html("");
                      $("#ajaxcart").html(result);
                      if ($(".mini-cart").hasClass("is-empty")) {
                        document
                          .querySelector(".mini-cart")
                          .classList.remove("is-empty");
                      }
                      setTimeout(function () {
                        document
                          .querySelector(".mini-cart")
                          .classList.add("animate", "active");
                        const checkbox =
                          document.getElementById("toggleCheckbox");
                        const button =
                          document.getElementById("ajaxcart-checkout");

                        // Function to enable/disable attribute manipulation
                        function toggleAttributeManipulation() {
                          if (checkbox.checked) {
                            // Enable the button
                            button.disabled = false;
                            // Add attribute to the button
                            button.setAttribute("data-custom", "example");
                          } else {
                            // Disable the button
                            button.disabled = true;
                            // Remove attribute from the button
                            button.removeAttribute("data-custom");
                          }
                        }

                        // Attach event listener to checkbox change event
                        checkbox.addEventListener(
                          "change",
                          toggleAttributeManipulation,
                        );
                      }, 200);
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                  fetch(url, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBodyCount),
                  })
                    .then((response) => {
                      return response.json();
                    })
                    .then((data) => {
                      var parsedCount = $.parseHTML(
                        data.sections["ajax-cart-icon"],
                      );
                      var resultCount = $(parsedCount)
                        .find(".bigcounter")
                        .html();
                      $(".bigcounter").html("");
                      $(".bigcounter").html(resultCount);
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                  setTimeout(function () {
                    $("#pro-add-" + pro_ID).removeClass("loading");
                    $("#pro-add-" + pro_ID)
                      .find(".ajax-loader")
                      .addClass("hidden");
                  }, 500);
                });
            });
          }, 500);
          window.relatedSwiper();

          const sliders = document.querySelectorAll(".swiper-wrapper");
          sliders.forEach(function (slider) {
            const sectionId = slider.getAttribute("data-section-id");
            const productId = slider.getAttribute("data-product-id");

            if (sectionId && productId) {
              window.initSwiper(sectionId, productId);
            }
          });
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class ajaxSearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    // MJ v20 (Oct 2026): only wire up when the input and its form are both there (see search-ajax.js)
    if (this.input && this.input.form) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        stdebounce((event) => {
          this.triggerChange(event);
        }, 300).bind(this),
      );
    }
  }
  ajaxResetBtn() {
    if (!this.input || !this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden");
    }
  }
  triggerChange() {
    this.ajaxResetBtn();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the ajax search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.ajaxResetBtn();
    }
  }
}
customElements.define("search-form", ajaxSearchForm);

if (!customElements.get("popup-view")) {
  customElements.define(
    "popup-view",
    class QuickAddModal extends stModalcontent {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }
      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("ajax-cart");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";
        if (preventFocus) this.openedBy = null;
        super.hide();
      }
      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".ajax-loader").classList.remove("hidden");
        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]',
            );
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            this.preSwatchURLswapping();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".ajax-loader").classList.add("hidden");
          });
      }
      setInnerHTML(element, html) {
        element.innerHTML = html;
        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML),
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
      preSwatchURLswapping() {
        const variantPicker = this.modalContent.querySelector(
          "pr-option,selects-box",
        );
        if (!variantPicker) return;
        variantPicker.setAttribute("data-update-url", "false");
      }
      removeDOMElements() {
        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();
        const modalDialog =
          this.productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }
      preventDuplicatedIDs() {
        const stScId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            stScId,
            `quickadd-${stScId}`,
          );
        this.productElement
          .querySelectorAll("selects-box, pr-option, product-info")
          .forEach((element) => {
            element.dataset.originalSection = stScId;
          });
      }
    },
  );
}
if (!customElements.get("cart-action")) {
  customElements.define(
    "cart-action",
    class stProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.triggerSendHand.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("ajax-cart");
        this.submitButton = this.querySelector('[type="submit"]');
      }
      triggerSendHand(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.stHandErrorTxt();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".ajax-loader").classList.remove("hidden");
        const config = stFetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.fetchSecToInclude().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.increase_cart_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.stHandErrorTxt(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error)
              live(SP_OBJECT.ajxcartRefresh, { source: "cart-action" });
            this.error = false;
            const quickAddModal = this.closest("popup-view");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".ajax-loader").classList.add("hidden");
          });
      }
      stHandErrorTxt(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".pr-form-error");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".pr-form-error-text");
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

// ---- Cart UI Refresh ----
(function () {
  const SECTION_CART = "ajax-cart";
  const SECTION_ICON = "ajax-cart-icon";
  let REFRESHING = false;

  function extractInner(html, selector) {
    const wrap = document.createElement("div");
    wrap.innerHTML = html;
    const node = wrap.querySelector(selector);
    return node ? node.innerHTML : "";
  }

  async function doRefreshCart() {
    if (REFRESHING) return;

    REFRESHING = true;

    try {
      const root =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root) ||
        "/";

      const url = `${root}?sections=${SECTION_CART},${SECTION_ICON}`;

      const res = await fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      const data = await res.json();

      if (data[SECTION_CART]) {
        const target = document.getElementById("ajaxcart");

        if (target) {
          target.innerHTML = extractInner(data[SECTION_CART], "#ajaxcart");
          const mini = document.querySelector(".mini-cart");
          if (mini) mini.classList.remove("is-empty");
        }
      }

      if (data[SECTION_ICON]) {
        const html = extractInner(data[SECTION_ICON], ".bigcounter");
        document
          .querySelectorAll(".bigcounter")
          .forEach((el) => (el.innerHTML = html));
      }
    } finally {
      REFRESHING = false;
    }
  }

  function refreshCart(cb) {
    doRefreshCart()
      .then(() => cb && cb(null))
      .catch((err) => {
        console.error(err);
        cb && cb(err);
      });
  }

  window.refreshCart = refreshCart;

  user(SP_OBJECT.ajxcartRefresh, (payload) => {
    if (payload && payload.__from === "ui-refresh") return;
    refreshCart();
  });
})();

// (function () {
//   const CART_ICON_SEL = '#ajax-cart-icon';
//   const POPOVER_CLASS = 'cp-popover';
//   const SHOW_CLASS = 'cp-show';

//   const elIcon = document.querySelector(CART_ICON_SEL);
//   if (!elIcon) return;

//   // keep your approved styles exactly
//   const style = document.createElement('style');
//   style.textContent = `
//     .${POPOVER_CLASS}{position:absolute; z-index:9999; width:480px; max-width:92vw; background:#fff; border:1px solid rgba(0,0,0,.08); box-shadow:0 10px 25px rgba(0,0,0,.15); border-radius:14px; padding:0; opacity:0; pointer-events:none; transform:translateY(0px); transition:opacity .15s, transform .15s;}
//     .${POPOVER_CLASS}.${SHOW_CLASS}{padding:18px; opacity:1; pointer-events:auto; transform:translateY(0);}
//     .${POPOVER_CLASS} .cp-header{display:flex; justify-content:space-between; align-items:center; font-weight:700; color:#1B2240; margin:0 0 14px;}
//     .${POPOVER_CLASS} .cp-total{opacity:.55;}
//     .${POPOVER_CLASS} ul{list-style:none; margin:0; padding:0; max-height:360px; overflow:auto;}
//     .${POPOVER_CLASS} li{display:flex; gap:14px; padding:10px 0; align-items:flex-start;}
//     .${POPOVER_CLASS} img{width:72px; height:72px; object-fit:cover; border-radius:10px; flex-shrink:0;}
//     .${POPOVER_CLASS} .cp-title{font-weight:600; color:#1B2240; line-height:1.35; word-break:break-word; overflow-wrap:anywhere; white-space:normal;}
//     .${POPOVER_CLASS} li > div{flex:1; min-width:0;}
//     .${POPOVER_CLASS} .cp-qty-price{color:#E7000B; font-weight:700; margin-top:4px;}
//     .${POPOVER_CLASS} .cp-actions{display:flex; gap:16px; margin-top:18px;}
//     .${POPOVER_CLASS} .cp-actions a{flex:1; text-align:center; padding:14px; border-radius:40px; font-weight:700; text-decoration:none; border:1px solid #192142; color:#192142;}
//     .${POPOVER_CLASS} .cp-actions a.checkout{background-color: #5a7670; border: none; color: white;}
//     @media (max-width: 991px){ .${POPOVER_CLASS}{display:none!important;} }
//   `;
//   document.body.appendChild(style);

//   const pop = document.createElement('div');
//   pop.className = POPOVER_CLASS;
//   document.body.appendChild(pop);

//   let hideTimer = null;
//   let lastCart = null;

//   const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;
//   const isCartPage = () =>
//     document.body.classList.contains('template-cart') ||
//     location.pathname.replace(/\/+$/, '') === '/cart';

//   const moneyFormat =
//     window.money_format ||
//     (window.theme && window.theme.moneyFormat) ||
//     (window.Shopify && Shopify.moneyFormat) ||
//     '{{amount}}'; // safe fallback; you already set theme.moneyFormat elsewhere

//   function clamp(val, min, max) {
//     return Math.min(Math.max(val, min), max);
//   }

//   function positionPopover() {
//     const r = elIcon.getBoundingClientRect();
//     const w = pop.offsetWidth || 480;
//     const h = pop.offsetHeight || 0;
//     const gap = 10;

//     const left = clamp(
//       r.right - w,                  // align right edges when possible
//       8,
//       window.innerWidth - w - 8
//     );
//     const top = clamp(r.bottom + gap, 8, window.innerHeight - h - 8);

//     pop.style.left = `${left + window.scrollX}px`;
//     pop.style.top  = `${top  + window.scrollY}px`;
//   }

//   function imgUrl(image) {
//     if (!image) return 'https://www.millieandjones.co.uk/cdn/shopifycloud/storefront/assets/no-image-160-46f2d4a0_150x150.gif';
//     // force a 200x200 crop for predictably sized thumbs
//     return image.replace(/(\.(jpg|jpeg|png|gif|webp))(?:\?.*)?$/i, `_200x200_crop_center$1`);
//   }

//   function renderCartPreview(cart) {
//     let html = `
//       <div class="cp-header">
//         <div>Your basket</div>
//         <div class="cp-total">Total: <b>${Shopify.formatMoney(cart.total_price, moneyFormat)}</b></div>
//       </div>
//       <ul>
//     `;

//     if (!cart.items || cart.items.length === 0) {
//       html += `
//         <div class="cp-empty" style="padding:10px 2px 6px; color:#666; font-weight:600;">
//           Your basket is empty
//         </div>
//       `;
//     } else {
//       cart.items.forEach((item) => {
//         html += `
//           <li>
//             <a href="${item.url}"><img src="${imgUrl(item.image)}" alt=""></a>
//             <div>
//               <div class="cp-title">${item.product_title}</div>
//               <div class="cp-qty-price">${item.quantity} × ${Shopify.formatMoney(item.final_price, moneyFormat)}</div>
//             </div>
//           </li>
//         `;
//       });
//       html += `</ul>
//         <div class="cp-actions">
//           <a class="view-cart" href="/cart">View basket</a>
//           <a class="checkout" href="/checkout">Checkout</a>
//         </div>
//       `;
//     }
//     pop.innerHTML = html;
//   }

//   function renderLoading() {
//     pop.innerHTML = `
//       <div class="cp-header">
//         <div>Your basket</div>
//         <div class="cp-total">Loading…</div>
//       </div>
//       <ul></ul>
//     `;
//   }

//   async function fetchCart() {
//     const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
//     const cart = await res.json();
//     lastCart = cart;
//     return cart;
//   }

//   function showNow() {
//     if (!isDesktop() || isCartPage()) return;

//     clearTimeout(hideTimer);

//     // immediate UI, then refresh content
//     if (lastCart) renderCartPreview(lastCart);
//     else renderLoading();

//     positionPopover();
//     pop.classList.add(SHOW_CLASS);

//     // update with fresh data in background
//     fetchCart()
//       .then((c) => {
//         if (pop.classList.contains(SHOW_CLASS)) {
//           renderCartPreview(c);
//           positionPopover();
//         }
//       })
//       .catch(() => {});
//   }

//   function scheduleHide() {
//     clearTimeout(hideTimer);
//     hideTimer = setTimeout(() => pop.classList.remove(SHOW_CLASS), 160);
//   }

//   // --- Hover wiring (instant & sticky) ---
//   if (!isCartPage()) {
//     elIcon.addEventListener('pointerenter', showNow);
//   }

//   elIcon.addEventListener('pointerleave', (e) => {
//     if (pop.contains(e.relatedTarget)) return; // moving into popup; keep it open
//     scheduleHide();
//   });

//   pop.addEventListener('pointerenter', () => clearTimeout(hideTimer));
//   pop.addEventListener('pointerleave', (e) => {
//     if (elIcon.contains(e.relatedTarget)) return; // moving back to icon
//     scheduleHide();
//   });

//   // Close if clicking outside both
//   document.addEventListener('pointerdown', (e) => {
//     if (!pop.classList.contains(SHOW_CLASS)) return;
//     if (pop.contains(e.target) || elIcon.contains(e.target)) return;
//     pop.classList.remove(SHOW_CLASS);
//   });

//   // Keep cache fresh when cart changes
//   if (typeof user === 'function' && window.SP_OBJECT?.ajxcartRefresh) {
//     user(SP_OBJECT.ajxcartRefresh, () => {
//       fetchCart()
//         .then((c) => {
//           if (pop.classList.contains(SHOW_CLASS)) renderCartPreview(c);
//         })
//         .catch(() => {});
//     });
//   }
//   // Prefetch once for snappy first hover
//   fetchCart().catch(() => {});

//   // --- Force click to go to /cart (override drawer open) ---
//   function goCart(e) {
//     if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // let users open in new tab
//     e.preventDefault();
//     e.stopPropagation();
//     e.stopImmediatePropagation();
//     location.assign('/cart');
//   }
//   // capture phase to beat the drawer’s handler
//   elIcon.addEventListener('click', goCart, true);
//   elIcon.addEventListener('keydown', (e) => {
//     if (e.code === 'Space' || e.code === 'Enter' || e.keyCode === 32 || e.keyCode === 13) {
//       goCart(e);
//     }
//   }, true);

//   // Reposition on resize/scroll if open
//   ['resize', 'scroll'].forEach((ev) =>
//     window.addEventListener(ev, () => {
//       if (pop.classList.contains(SHOW_CLASS)) positionPopover();
//     })
//   );
// })();
(function () {
  const CART_ICON_SEL = "#ajax-cart-icon";
  const POPOVER_CLASS = "cp-popover";
  const SHOW_CLASS = "cp-show";

  const elIcon = document.querySelector(CART_ICON_SEL);
  if (!elIcon) return;

  // keep your approved styles exactly
  const style = document.createElement("style");
  style.textContent = `
    .${POPOVER_CLASS}{position:absolute; z-index:9999; width:480px; max-width:92vw; background:#fff; border:1px solid rgba(0,0,0,.08); box-shadow:0 10px 25px rgba(0,0,0,.15); border-radius:14px; padding:0; opacity:0; pointer-events:none; transform:translateY(0px); transition:opacity .15s, transform .15s;}
    .${POPOVER_CLASS}.${SHOW_CLASS}{padding:18px; opacity:1; pointer-events:auto; transform:translateY(0);}
    .${POPOVER_CLASS} .cp-header{display:flex; justify-content:space-between; align-items:center; font-weight:700; color:#1B2240; margin:0 0 14px;}
    .${POPOVER_CLASS} .cp-total{opacity:.55;}
    .${POPOVER_CLASS} ul{list-style:none; margin:0; padding:0; max-height:360px; overflow:auto;}
    .${POPOVER_CLASS} li{display:flex; gap:14px; padding:10px 0; align-items:flex-start;}
    .${POPOVER_CLASS} img{width:72px; height:72px; object-fit:cover; border-radius:10px; flex-shrink:0;}
    .${POPOVER_CLASS} .cp-title{font-weight:600; color:#1B2240; line-height:1.35; word-break:break-word; overflow-wrap:anywhere; white-space:normal;}
    .${POPOVER_CLASS} li > div{flex:1; min-width:0;}
    .${POPOVER_CLASS} li.cp-surcharge, .${POPOVER_CLASS} li.cp-surcharge .cp-thumb, .${POPOVER_CLASS} li.cp-surcharge .cp-title{cursor:default;}
    .${POPOVER_CLASS} .cp-qty-price{color:#E7000B; font-weight:700; margin-top:4px;}
    .${POPOVER_CLASS} .cp-actions{display:flex; gap:16px; margin-top:18px;}
    .${POPOVER_CLASS} .cp-actions a{flex:1; text-align:center; padding:14px; border-radius:40px; font-weight:700; text-decoration:none; border:1px solid #192142; color:#192142;}
    .${POPOVER_CLASS} .cp-actions a.checkout{background-color: #5a7670; border: none; color: white;}
    .${POPOVER_CLASS} .cp-actions a.empty-cart{background-color: #dc2626; border: none; color: white;}
    @media (max-width: 991px){ .${POPOVER_CLASS}{display:none!important;} }
  `;
  document.body.appendChild(style);

  const pop = document.createElement("div");
  pop.className = POPOVER_CLASS;
  document.body.appendChild(pop);

  let hideTimer = null;
  let lastCart = null;

  const isDesktop = () => window.matchMedia("(min-width: 992px)").matches;
  const isCartPage = () =>
    document.body.classList.contains("template-cart") ||
    location.pathname.replace(/\/+$/, "") === "/cart";

  const moneyFormat =
    window.money_format ||
    (window.theme && window.theme.moneyFormat) ||
    (window.Shopify && Shopify.moneyFormat) ||
    "{{amount}}";

  function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
  }

  function positionPopover() {
    const r = elIcon.getBoundingClientRect();
    const w = pop.offsetWidth || 480;
    const h = pop.offsetHeight || 0;
    const gap = 10;

    const left = clamp(r.right - w, 8, window.innerWidth - w - 8);
    const top = clamp(r.bottom + gap, 8, window.innerHeight - h - 8);

    pop.style.left = `${left + window.scrollX}px`;
    pop.style.top = `${top + window.scrollY}px`;
  }

  function imgUrl(image) {
    if (!image)
      return "https://www.millieandjones.co.uk/cdn/shopifycloud/storefront/assets/no-image-160-46f2d4a0_150x150.gif";
    return image.replace(
      /(\.(jpg|jpeg|png|gif|webp))(?:\?.*)?$/i,
      `_200x200_crop_center$1`,
    );
  }

  function renderCartPreview(cart) {
    let html = `
      <div class="cp-header">
        <div>Your basket</div>
        <div class="cp-total">Total: <b>${Shopify.formatMoney(
          cart.total_price,
          moneyFormat,
        )}</b></div>
      </div>
      <ul>
    `;

    if (!cart.items || cart.items.length === 0) {
      html += `
        <div class="cp-empty" style="padding:10px 2px 6px; color:#666; font-weight:600;">
          Your basket is empty
        </div>
      `;
    } else {
      cart.items.forEach((item) => {
        // The weekend delivery surcharge is added by the cart's delivery date
        // picker (snippets/cart-delivery-date.liquid), not chosen by the
        // shopper, so it links nowhere - sending someone to its product page
        // invites them to buy a delivery fee on its own. The title here is
        // already plain text; only the thumbnail was a link. Mirrors the same
        // treatment in sections/cart-section.liquid and snippets/ajax-cart.liquid.
        const isSurcharge =
          (item.properties || {})["_weekend_surcharge"] === "true";
        const thumb = `<img src="${imgUrl(item.image)}" alt="">`;
        html += `
          <li${isSurcharge ? ' class="cp-surcharge"' : ""}>
            ${
              isSurcharge
                ? `<span class="cp-thumb">${thumb}</span>`
                : `<a href="${item.url}">${thumb}</a>`
            }
            <div>
              <div class="cp-title">${item.product_title}</div>
              <div class="cp-qty-price">${
                item.quantity
              } × ${Shopify.formatMoney(item.final_price, moneyFormat)}</div>
            </div>
          </li>
        `;
      });
      html += `</ul>
        <div class="cp-actions">
          <a class="view-cart" href="/cart">View basket</a>
          <a class="checkout" href="/checkout">Checkout</a>
          <a class="empty-cart" href="#">Empty basket</a>
        </div>
      `;
    }
    pop.innerHTML = html;

    // Add empty cart button functionality
    const emptyBtn = pop.querySelector(".empty-cart");
    if (emptyBtn) {
      emptyBtn.addEventListener("click", handleEmptyCart);
    }
  }

  function renderLoading() {
    pop.innerHTML = `
      <div class="cp-header">
        <div>Your basket</div>
        <div class="cp-total">Loading…</div>
      </div>
      <ul></ul>
    `;
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
    });
    const cart = await res.json();
    lastCart = cart;
    return cart;
  }

  // async function handleEmptyCart(e) {
  //   e.preventDefault();

  //   if (!confirm('Are you sure you want to empty your cart?')) {
  //     return;
  //   }

  //   try {
  //     // Show loading state
  //     renderLoading();

  //     // Clear the cart using Shopify's API
  //     await fetch('/cart/clear.js', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' }
  //     });

  //     // Fetch updated cart
  //     const cart = await fetchCart();

  //     // Update the popover
  //     renderCartPreview(cart);
  //     positionPopover();

  //     // Trigger cart refresh for other parts of the page
  //     if (typeof user === 'function' && window.SP_OBJECT?.ajxcartRefresh) {
  //       user(SP_OBJECT.ajxcartRefresh);
  //     }

  //   } catch (error) {
  //     console.error('Error emptying cart:', error);
  //     alert('Failed to empty cart. Please try again.');
  //   }
  // }

  async function handleEmptyCart(e) {
    e.preventDefault();

    if (!confirm("Empty your basket?")) {
      return;
    }

    try {
      // Show loading state
      renderLoading();

      // Clear the cart using Shopify's API
      await fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      // Refresh cart UI (drawer and icon) first
      if (typeof window.refreshCart === "function") {
        await new Promise((resolve) => {
          window.refreshCart((err) => {
            if (err) console.error("Cart refresh error:", err);
            resolve();
          });
        });
      }

      // Then fetch and update the popover
      const cart = await fetchCart();
      renderCartPreview(cart);
      positionPopover();
    } catch (error) {
      console.error("Error emptying cart:", error);
      alert("We could not empty your basket. Please try again.");
      // Restore popover to last known state
      if (lastCart) {
        renderCartPreview(lastCart);
      }
    }
  }

  function showNow() {
    if (!isDesktop() || isCartPage()) return;

    clearTimeout(hideTimer);

    if (lastCart) renderCartPreview(lastCart);
    else renderLoading();

    positionPopover();
    pop.classList.add(SHOW_CLASS);

    fetchCart()
      .then((c) => {
        if (pop.classList.contains(SHOW_CLASS)) {
          renderCartPreview(c);
          positionPopover();
        }
      })
      .catch(() => {});
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => pop.classList.remove(SHOW_CLASS), 160);
  }

  if (!isCartPage()) {
    elIcon.addEventListener("pointerenter", showNow);
  }

  elIcon.addEventListener("pointerleave", (e) => {
    if (pop.contains(e.relatedTarget)) return;
    scheduleHide();
  });

  pop.addEventListener("pointerenter", () => clearTimeout(hideTimer));
  pop.addEventListener("pointerleave", (e) => {
    if (elIcon.contains(e.relatedTarget)) return;
    scheduleHide();
  });

  document.addEventListener("pointerdown", (e) => {
    if (!pop.classList.contains(SHOW_CLASS)) return;
    if (pop.contains(e.target) || elIcon.contains(e.target)) return;
    pop.classList.remove(SHOW_CLASS);
  });

  if (typeof user === "function" && window.SP_OBJECT?.ajxcartRefresh) {
    user(SP_OBJECT.ajxcartRefresh, () => {
      fetchCart()
        .then((c) => {
          if (pop.classList.contains(SHOW_CLASS)) renderCartPreview(c);
        })
        .catch(() => {});
    });
  }

  fetchCart().catch(() => {});

  function goCart(e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    location.assign("/cart");
  }

  elIcon.addEventListener("click", goCart, true);
  elIcon.addEventListener(
    "keydown",
    (e) => {
      if (
        e.code === "Space" ||
        e.code === "Enter" ||
        e.keyCode === 32 ||
        e.keyCode === 13
      ) {
        goCart(e);
      }
    },
    true,
  );

  ["resize", "scroll"].forEach((ev) =>
    window.addEventListener(ev, () => {
      if (pop.classList.contains(SHOW_CLASS)) positionPopover();
    }),
  );
})();

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

document.addEventListener("click", (event) => {
  document.querySelectorAll("details").forEach((details) => {
    if (details.open && !details.contains(event.target)) {
      details.open = false; // Close if clicking outside
    }
  });
});

// Add this at the very end of your plugin.js file

// Global Variables for Sticky Component Integration
window.selectedMainVariantId = null;
window.selectedPrice = 0;
window.selectedComparePrice = 0;
window.selectedMainQuantity = 1;

// Function to update global variant data
function updateGlobalVariantData() {
  const variantIdInput = document.querySelector('input[name="id"]');
  const variantPrice = document.querySelector("#ProductPrice");
  const variantComparePrice = document.querySelector("#ComparePrice");

  if (variantIdInput) {
    window.selectedMainVariantId = variantIdInput.value;
    window.selectedPrice = variantPrice.textContent;
    window.selectedComparePrice = variantComparePrice.textContent;
  }

  // Update sticky component inputs if they exist
  updateStickyInputs();

  // Dispatch event so sticky-addon.js can recalculate total with addons
  document.dispatchEvent(new CustomEvent("stickyPriceUpdated"));
}

// Function to update sticky component inputs
function updateStickyInputs() {
  const stickyVariantInput = document.querySelector(".sticky-variant-id");
  const stickyQuantityInput = document.querySelector(".sticky-quantity");
  const stickyPrice = document.querySelector("#StickyProductPrice");
  const stickyComparePrice = document.querySelector("#StickyComparePrice");
  const savingPrice = document.querySelector("#Saving");

  if (stickyVariantInput && window.selectedMainVariantId) {
    stickyVariantInput.value = window.selectedMainVariantId;
  }

  if (stickyPrice && window.selectedPrice) {
    stickyPrice.textContent = window.selectedPrice;
  }

  if (stickyComparePrice && window.selectedComparePrice) {
    stickyComparePrice.textContent = window.selectedComparePrice;
  }

  if (
    stickyPrice &&
    window.selectedPrice &&
    stickyComparePrice &&
    window.selectedComparePrice &&
    savingPrice
  ) {
    const comparePriceNum = parseFloat(
      window.selectedComparePrice.replace(/[£,]/g, ""),
    );
    const selectedPriceNum = parseFloat(
      window.selectedPrice.replace(/[£,]/g, ""),
    );
    const savings = comparePriceNum - selectedPriceNum;

    savingPrice.textContent = "£" + savings.toFixed(2);
  }

  if (stickyQuantityInput) {
    stickyQuantityInput.value = 1; // Always 1
  }
}

// Initialize and listen for variant changes
document.addEventListener("DOMContentLoaded", function () {
  // Initialize on page load
  setTimeout(updateGlobalVariantData, 100); // Small delay to ensure DOM is ready

  // Listen for the custom swatchUpdate event that your existing code already fires
  user(SP_OBJECT.swatchUpdate, function (data) {
    setTimeout(updateGlobalVariantData, 50);
  });

  // Also listen for direct changes to the variant input
  const mainVariantInput = document.querySelector('input[name="id"]');
  if (mainVariantInput) {
    // Watch for value changes using polling since your code updates it programmatically
    let lastValue = mainVariantInput.value;
    setInterval(() => {
      if (mainVariantInput.value !== lastValue) {
        lastValue = mainVariantInput.value;
        updateGlobalVariantData();
      }
    }, 200);
  }
});
